import React, { Component } from 'react';
import {
    FormGroup,
    Col,
    ControlLabel
} from 'react-bootstrap';
import Calendar from 'react-datetime';
import moment from 'moment';
import '../../public/less/datepicker.less';
import dateHelper from '../../helpers/date.js';

module.exports = class BirthDate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            birthdate: dateHelper.fromDateToStrWithoutTime(moment().add(-10, "years").toDate())
        };
    }

    handleChange(date) {
        this.setState({ birthdate: date })
        //this.toggleCalendar()
    }

    changeValue(val) {
        this.setState({ birthdate: val });
    }


    valid(current){
        return current.isBefore(Calendar.moment());
    }


    render() {
        var input;
        var obj = {name: 'birthdate'};
        if (this.props.status == 'edit' || this.props.status == 'new') {
            input = <Calendar dateFormat="DD.MM.YYYY" timeFormat={false}  inputProps={obj} value={this.state.birthdate} onChange={this.handleChange.bind(this)} isValidDate={ this.valid.bind(this)} />
        }
        else {
            input = <label>{this.state.birthdate}</label>
        }
        return (
            <FormGroup>
                <link rel="stylesheet" type="text/css" href="/css/react-datepicker.min.css" />
                <Col componentClass={ControlLabel} lg={2}>
                    {this.props.caption}
                </Col>
                <Col lg={10}>
                    {input}
                </Col>
            </FormGroup>
        )
    }
};



// WEBPACK FOOTER //
// ./modules/register/BirthDate.jsx